import React from 'react';

export function LogBox({ text }: { text: string }) {
  return (
    <pre className="text-xs whitespace-pre-wrap bg-muted rounded p-2 max-h-80 overflow-auto">
      {text || '(no output yet)'}
    </pre>
  );
}